module.exports = __webpack_public_path__ + "static/img/asso-lard.fba83db.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/projets/asso-lard.jpg
// module id = m+Az
// module chunks = 1